import React from 'react';
import AuthLayout from 'layouts/AuthLayout';
import LoginForm from "./LoginForm";
import {Link, useNavigate} from "react-router-dom";

const LoginPage = () => {
    const navigate = useNavigate();
    const onLoginSuccess = () => {
        navigate(`/`);
    }

    return (
        <AuthLayout>
            <div className="login-page">
                <h5>Login</h5>
                <LoginForm onLoginSuccess={onLoginSuccess}/>
                <Link to="/auth/forgot-password">Forgot Password?</Link>
            </div>
        </AuthLayout>
    )
}

export default LoginPage;